import React, { useEffect, useState } from "react";
import { HubConnectionBuilder } from "@microsoft/signalr";
import { GoogleMap, MarkerF, useLoadScript } from "@react-google-maps/api";

const mapContainerStyle = {
  width: "100%",
  height: "700px"
};

const center = {
  lat: 39.8283, // Center of USA
  lng: -98.5795
};

const getMarkerIcon = (status: string) => {
  //if valid use blue color
  //if invalid use red color
  //if unknown use yellow color
  const color = status === "Valid" ? "#0000FF" : status === "Invalid" ? "#FF0000" : "#FFFF00";

  return {
    url: `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='${encodeURIComponent(
      color
    )}'%3E%3Cpath d='M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z'/%3E%3C/svg%3E`,
    scaledSize: new window.google.maps.Size(32, 32),
    anchor: new window.google.maps.Point(16, 32)
  };
};

const AddressValidateFeedback: React.FC = () => {
  const [pins, setPins] = useState<any[]>([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || ""
  });

  useEffect(() => {
    const baseUrl =
      process.env.NODE_ENV === "development"
        ? "http://localhost:5000"
        : "https://address.api-bettertrucks.com";

    const baseUrlUpdated = `https://address.api-bettertrucks.com/addressValidateHub`;

    const connection = new HubConnectionBuilder()
      .withUrl(`${baseUrlUpdated}`)
      .withAutomaticReconnect()
      .build();

    connection
      .start()
      .then(() => {
        connection.on("addressValidateHub", (data) => {
          console.log('addressValidateHub (data)', data);
          setPins((prev) => [...prev, data]);
        });
      })
      .catch((err) => console.error("SignalR connection error:", err));

    return () => {
      connection.stop();
    };
  }, [refreshKey]);

  const handleClearPins = () => setPins([]);
  const handleRefresh = () => {
    setPins([]);
    setRefreshKey((k) => k + 1);
  };

  return (
    <div className="main-content">
      <div style={{ position: 'relative' }}>
        <div style={{ position: 'absolute', top: 0, right: 0, zIndex: 2, display: 'flex', gap: '8px' }}>
          <button
            className="btn btn-outline-danger"
            onClick={handleClearPins}
          >
            Clear Pins
          </button>
          <button
            className="btn btn-outline-primary"
            onClick={handleRefresh}
          >
            Refresh
          </button>
        </div>
        <h2>Address Validate Feedback</h2>
        <p>Watch this map for real-time address validation updates</p>
        {isLoaded ? (
          <GoogleMap
            key={refreshKey}
            mapContainerStyle={mapContainerStyle}
            center={center}
            zoom={5}
          >
            {pins.map((pin, idx) =>
              pin.latitude && pin.longitude ? (
                <MarkerF
                  key={idx}
                  position={{ lat: pin.latitude, lng: pin.longitude }}
                  icon={getMarkerIcon(pin.status)}
                />
              ) : null
            )}
          </GoogleMap>
        ) : (
          <div>Loading map...</div>
        )}
      </div>
    </div>
  );
};

export default AddressValidateFeedback; 